exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promo-code[data-v-6b12ec2e]{padding:var(--spacer-lg) 0 var(--spacer-lg)}.promo-code__form[data-v-6b12ec2e]{display:-ms-flexbox;display:flex;-ms-flex-align:baseline;align-items:baseline}.promo-code__link-container[data-v-6b12ec2e]{display:block;text-align:end}.promo-code__circle-icon[data-v-6b12ec2e]{--button-size: 2rem;--icon-size: 0.6875rem}.promo-code__input[data-v-6b12ec2e]{--input-background: var(--c-white);-ms-flex:1 1;flex:1 1;margin:0 var(--spacer-lg) 0 0}.promo-code__button[data-v-6b12ec2e]{--button-height: 2rem;--button-font-size: 0.6875rem}\n", ""]);

// exports
